<template>
  <div class="home-page">
    <MyHeader ref="headerRef" />
    <!-- 轮播图 -->
    <div class="carousel-container">
      <el-carousel
          :interval="6000"
          :type="carouselType"
          :height="carouselHeight + 'px'"
          :cardScale="carouselType === 'card' ? 0.8 : undefined"
          @change="handleCarouselChange"
          class="custom-carousel"
          arrow="always"
          :autoplay="false"
      >
        <el-carousel-item
            v-for="(item, index) in productVideos"
            :key="index"
            class="video-carousel-item"
            :style="{ height: '100%' }"
        >
          <div class="video-container">
            <div class="video-loading" v-if="item.loading && !item.error">
              <i class="fas fa-spinner fa-spin"></i>
              <p>{{ $t('home.video.loading') }}</p>
            </div>

            <div class="video-error" v-if="item.error">
              <i class="fas fa-exclamation-triangle"></i>
              <p>{{ $t('home.video.error') }}</p>
            </div>

            <video
                ref="videoRefs"
                :id="'video-' + index"
                :src="item.src"
                class="product-video"
                loop
                playsinline
                webkit-playsinline
                preload="auto"
                @loadeddata="handleVideoLoaded(index)"
                @error="handleVideoError(index)"
            >
              {{ $t('home.video.notSupported') }}
            </video>

<!--            <div class="play-button" @click="toggleVideoPlay(index)" v-if="!item.error">
              <i class="fas" :class="item.playing ? 'fa-pause' : 'fa-play'"></i>
            </div>-->

            <div
                class="play-button"
                @click="toggleVideoPlay(index)"
                v-if="!item.error"
                :class="{ 'play-button--hidden': item.playing }"
            >
              <i class="fas" :class="item.playing ? 'fa-pause' : 'fa-play'"></i>
            </div>

            <div class="video-info">
              <h3 class="video-title">{{ $t(`home.productVideos.${index}.title`) }}</h3>
              <p class="video-desc">{{ $t(`home.productVideos.${index}.description`) }}</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 其他内容 -->
    <CategorySection
        :title="$t('home.category.title')"
        :subtitle="$t('home.category.subtitle')"
        :categories="categories"
        @category-clicked="handleCategoryClick"
    />
    <VideoSection
        :title="$t('home.videoSection.title')"
        :videos="videos"
    />
    <Cainixihuan />
    <TextVideo :videos="companyUrl" />
    <AdvantagesSection :advantages="computedAdvantages" />
    <div style="height: 30px"></div>
    <MyFoot ref="footerRef" />
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader";
import MyFoot from "@/components/MyFoot";
import Cainixihuan from "@/components/CaiNiLike";
import AdvantagesSection from "@/components/AdvantagesSection";
import CategorySection from "@/components/CategorySection";
import VideoSection from "@/components/VideoSection";
import TextVideo from "@/components/TextVideo"
export default {
  name: 'HomePage',
  data() {
    return {
      carouselType: 'card',
      carouselHeight: 400,
      productVideos: [
        {
          src: require('@/assets/video/linshi/47T.mp4'),
          loading: true,
          error: false,
          playing: false
        },
        {
          src: require('@/assets/video/linshi/36T.mp4'),
          loading: true,
          error: false,
          playing: false
        },
        {
          src: require('@/assets/video/linshi/G6.mp4'),
          loading: true,
          error: false,
          playing: false
        }
      ],
      currentPlayingIndex: -1,
      // 优势数据只保留图片，文本从i18n获取
      advantages: [
        {
          icon: require('@/assets/youshi/ico-shield.svg'),
          i18nKey: 'advantage1'
        },
        {
          icon: require('@/assets/youshi/SAE-Badge.webp'),
          i18nKey: 'advantage2'
        },
        {
          icon: require('@/assets/youshi/ico-time.svg'),
          i18nKey: 'advantage3'
        },
        {
          icon: require('@/assets/youshi/ico-package.svg'),
          i18nKey: 'advantage4'
        }
      ],
      companyUrl: [
        {
          id: 1,
          name: this.$t('home.videos.companyVideo'),
          src: require('@/assets/video/show.mp4'),
          width: '100%',
          height: 'auto'
        }],
    };
  },
  components: {
    MyHeader,
    MyFoot,
    Cainixihuan,
    AdvantagesSection,
    CategorySection,
    VideoSection,
    TextVideo
  },
  computed: {
    // 从i18n获取优势文本
    computedAdvantages() {
      return this.advantages.map(item => ({
        ...item,
        title: this.$t(`home.advantages.${item.i18nKey}.title`),
        detail: this.$t(`home.advantages.${item.i18nKey}.detail`)
      }));
    },
    categories() {
      return [
        { id: 1, name: this.$t('home.categories.miniLightBars'), image: require('@/assets/product/touming/T/18T2.png') },
        { id: 2, name:this.$t('home.categories.fullLightBars'), image: require('@/assets/product/touming/T/47T2.png') },
        { id: 3, name: this.$t('home.categories.visorLightBars'), image: require('@/assets/product/touming/T/ZY41.webp') },
        { id: 4, name: this.$t('home.categories.deckDashLights'), image: require('@/assets/product/touming/T/G23.png') },
        { id: 5, name: this.$t('home.categories.grilleSurfaceMounts'), image: require('@/assets/product/touming/T/Z4T1.png') },
        { id: 6, name: this.$t('home.categories.siren'), image: require('@/assets/product/touming/JBQ/A13.png') },
        { id: 7, name: this.$t('home.categories.trafficAdvisors'), image: require('@/assets/product/touming/T/G63.png') },
        { id: 8, name: this.$t('home.categories.mountingBrackets'), image: require('@/assets/product/PJ/QDSTVB2.png') },
      ]
    },
    videos(){
      return  [
        {
          id: 1,
          name: this.$t('home.videos.trafficAdvisors'),
          src: require('@/assets/video/gangdeng.mp4'),
          width: '100%',
          height: 'auto'
        },
        {
          id: 2,
          name: this.$t('home.videos.miniLightBars'),
          src: require('@/assets/video/minibar.mp4'),
          width: '100%',
          height: 'auto'
        }
      ]
    }
  },
  methods: {
    handleWindowResize() {
      const screenWidth = window.innerWidth;
      this.carouselType = screenWidth > 768 ? 'card' : 'common';
      this.calculateCarouselHeight();
    },
    calculateCarouselHeight() {
      this.$nextTick(() => {
        const headerEl = this.$refs.headerRef?.$el;
        const footerEl = this.$refs.footerRef?.$el;

        if (!headerEl || !footerEl) {
          this.carouselHeight = window.innerWidth > 768 ? 400 : 300;
          return;
        }

        const headerHeight = headerEl.offsetHeight;
        const footerHeight = footerEl.offsetHeight;

        if (window.innerWidth <= 768) {
          this.carouselHeight = window.innerHeight - headerHeight - footerHeight - 60;
          if (this.carouselHeight < 250) {
            this.carouselHeight = 250;
          }
        } else {
          this.carouselHeight = 400;
        }
      });
    },
    handleCategoryClick(categoryId) {
      this.$router.push({name: 'PdtList', params: {categoryId}});
    },
    toggleVideoPlay(index) {
      const video = this.$refs.videoRefs[index];
      if (!video || this.productVideos[index].error) return;

      if (video.paused) {
        this.productVideos.forEach((item, i) => {
          if (i !== index && item.playing) {
            const otherVideo = this.$refs.videoRefs[i];
            otherVideo && otherVideo.pause();
            this.productVideos[i].playing = false;
          }
        });
        video.play();
        this.productVideos[index].playing = true;
      } else {
        video.pause();
        this.productVideos[index].playing = false;
      }
    },
    handleCarouselChange() {
      this.productVideos.forEach((item, i) => {
        if (item.playing) {
          const video = this.$refs.videoRefs[i];
          video && video.pause();
          this.productVideos[i].playing = false;
        }
      });
    },
    handleVideoLoaded(index) {
      this.productVideos[index].loading = false;
    },
    handleVideoError(index) {
      this.productVideos[index].loading = false;
      this.productVideos[index].error = true;
      console.error(`视频 ${index} 加载失败`);
    }
  },
  mounted() {
    this.handleWindowResize();
    window.addEventListener('resize', this.handleWindowResize);

    this.productVideos.forEach((item, index) => {
      if (item.poster) {
        const img = new Image();
        img.src = item.poster;
        img.onerror = () => {
          const videoEl = document.getElementById(`video-${index}`);
          if (videoEl) {
            videoEl.style.backgroundColor = "#f0f0f0";
          }
        };
      }
    });
    window.scrollTo(0, 0);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
};
</script>

<style scoped>
/* 原有样式保持不变 */
.home-page {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.carousel-container {
  width: 100%;
  max-width: 85%;
  margin: 0 auto;
  padding: 30px 50px;
}

.custom-carousel {
  --el-carousel-card-width: 85%;
}

.video-carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  min-width: 320px;
}

.video-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 300px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  background-color: #000;
  margin: 0 10px;
}

.product-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  min-height: 300px;
  background-color: #000;
}

.video-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #000;
  color: #fff;
  z-index: 20;
}

.video-loading i {
  font-size: 40px;
  margin-bottom: 15px;
  animation: spin 1.5s linear infinite;
}

.video-error {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #000;
  color: #ff4d4f;
  z-index: 20;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  opacity: 1;
}
/* 播放状态下默认隐藏按钮 */
.play-button--hidden {
  opacity: 0;
  pointer-events: none; /* 隐藏时禁止点击，避免误触 */
}

/* 鼠标 hover 视频容器时，即使播放中也显示按钮 */
.video-container:hover .play-button--hidden {
  opacity: 1;
  pointer-events: auto;
}

.play-button:hover {
  transform: translate(-50%, -50%) scale(1.1);
  background-color: rgba(255, 255, 255, 0.5);
}

.play-button i {
  color: #fff;
  font-size: 28px;
  margin-left: 5px;
}

.video-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: white;
  transform: translateY(20px);
  opacity: 0;
  transition: all 0.3s ease;
}

.video-container:hover .video-info {
  transform: translateY(0);
  opacity: 1;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 手机端样式 */
@media (max-width: 768px) {
  .carousel-container {
    max-width: 100%;
    padding: 15px 10px;
  }

  .custom-carousel {
    --el-carousel-card-width: 100%;
  }

  .video-carousel-item {
    padding: 0;
    min-width: 100%;
  }

  .video-container {
    min-height: 220px;
    margin: 0;
    width: 90% !important;
  }

  .play-button {
    width: 60px;
    height: 60px;
  }

  .play-button i {
    font-size: 22px;
    margin-left: 5px;
  }

  .video-info {
    padding: 12px;
  }

  .video-title {
    font-size: 14px;
  }

  .video-desc {
    font-size: 12px;
  }
}
</style>
